module.exports = __webpack_public_path__ + "media/ParksGardens.82f33da1.svg";